import React, { useState } from 'react'
import { IconInfo } from '../../svg/index';
import Modal from "react-modal";
import { ImgPlaca, ImgChasis, ImgColor, ImgMotor } from "../../svg/index";


const ButtonInfo = ({ type = '' }) => {
    const styleCss = {
        width: "10%"
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const Show = () => {
    }

    const switchImg = (key) => {
        switch (key) {
            case "Placa":
                return <ImgPlaca width="100%" />
            case "Motor":
                return <ImgMotor width="100%" />
            case "Chasis":
                return <ImgChasis width="100%" />
            case "Color":
                return <ImgColor width="100%" />
            default:
                break;
        }
    }

    return (
        <div style={styleCss}>
            <button className="btn-info" type="button" src={IconInfo} onClick={handleShow} tabindex="-1"  >
                <IconInfo />
            </button>

            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Campos a ingresar según circulación</span>
                </div>
                <div className="modal-body-info">
                    {switchImg(type)}
                </div>
                <div className="modal-footer">
                    <button type="button" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );

}

export default ButtonInfo;
